export * from "@workspace/gamja-platform/lib/pass-sales";
import { isPremiumCompletePassSaleClosed as isSeasonSaleClosed, type PassSalesTimeInput } from "@workspace/gamja-platform/lib/pass-sales";
import { isDiscontinuedCompleteProduct } from "./jcg-sales-policy";

/** JCG 전용 신규 판매 정책. 과거 권한 판정은 공통 구현을 유지한다. */
export function isPremiumCompletePassSaleClosed(productId: string, now: PassSalesTimeInput = Date.now()): boolean {
  return isDiscontinuedCompleteProduct(productId, now) || isSeasonSaleClosed(productId, now);
}

// 이번 가격 전환의 판매 중단만 Starter에 적용한다. 이후 시험별 중단을 상속하지 않는다.
import { getPremiumCompletePassSalesStatus as getSeasonStatus, PREMIUM_COMPLETE_PASS_SALES_SEASONS } from "@workspace/gamja-platform/lib/pass-sales";
import { STARTER_PASS_PRODUCT_ID } from "@/types/pass";

export function isStarterPassSaleClosed(now?: PassSalesTimeInput): boolean {
  const end = PREMIUM_COMPLETE_PASS_SALES_SEASONS.find(s => s.sessionId === "2026-3")!.salesEndAtISO!;
  const restart = PREMIUM_COMPLETE_PASS_SALES_SEASONS.find(s => s.sessionId === "2027-1")!.salesStartAtISO!;
  const time = now === undefined ? Math.max(Date.now(), Date.parse(end)) : new Date(now).getTime();
  return time >= Date.parse(end) && time < Date.parse(restart);
}

export function isPassSaleClosed(productId: string, now?: PassSalesTimeInput): boolean {
  const validationTime = now ?? Math.max(Date.now(), Date.parse("2026-10-25T00:00:00+09:00"));
  return productId === STARTER_PASS_PRODUCT_ID
    ? isStarterPassSaleClosed(validationTime)
    : isPremiumCompletePassSaleClosed(productId, validationTime);
}

export const PASS_SALES_CLOSED_ERROR = "이용권 판매가 중단되었습니다. 판매 재개 일정을 확인해주세요.";

/** 이번 배포의 판매 화면은 27년 1회를 안내한다. 과거 권한·거래 시각은 보존한다. */
export function getMembershipSalesStatus(now: PassSalesTimeInput = Date.now()) {
  return getSeasonStatus(Math.max(new Date(now).getTime(), Date.parse("2026-10-25T00:00:00+09:00")));
}
